import { Box, Stack } from '@mui/material';

type Sponsor = { name: string; imageUrl?: string };

export interface PreviewSponsorsLayerProps {
  sponsorsJson?: string;
}

/** Sponsor strip sized to the layer box (player uses vh/vw which break in embedded previews). */
export function PreviewSponsorsLayer({ sponsorsJson }: PreviewSponsorsLayerProps) {
  let sponsors: Sponsor[] = [];
  try {
    const parsed = JSON.parse(sponsorsJson || '[]');
    sponsors = Array.isArray(parsed) ? parsed : [];
  } catch {
    sponsors = [];
  }
  const withImages = sponsors.filter((sponsor) => sponsor?.imageUrl);
  if (withImages.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1,
        }}
      >
        {withImages.map((sponsor, index) => (
          <Box
            key={`sponsor-${index}`}
            sx={{
              flex: '1 1 0',
              minWidth: 0,
              maxHeight: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              component="img"
              src={sponsor.imageUrl}
              alt={sponsor.name || 'Sponsor'}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: 0.5,
              }}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
